const data = {
  yellowBlobTitle: 'What would they choose?',
  yellowBlobDescription:
    'Skipping the formal funeral service frees you up to remember your loved one in a more fitting way. You could…',

  bubble1: {
    image: 'e_trim/illustrations/hire-the-town-hall',
    content: 'Enjoy their favourite view or walk',
  },
  bubble2: {
    image: 'e_trim/illustrations/make-it-a-party',
    content: 'Get everyone together for a big send-off',
  },
  bubble3: {
    image: 'e_trim/illustrations/have-a-family-feast',
    content: 'Cook and share a meal they loved ',
  },
  bubble4: {
    image: 'e_trim/illustrations/coins-turtle-revised',
    content: 'Fundraise for a charity close to their heart',
  },
}

export default data
